import {Component, EventEmitter, OnInit, Output, Renderer2, ViewChild} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort, MatSortable} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {LoginModel} from 'src/app/model/login.model';
import {AuthenticationService} from 'src/app/services/authentication.service';
import {SnackBarService} from 'src/app/services/snack-bar-service.service';
import {SubfrotaService} from '../subfrota.service';
import {FiltroAbastecimentosViewModel} from "../model/filtro-abastecimentos-view-model";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {NomeCombustivel} from "../../precos-combustiveis/model/AlteracaoCombustivel";
import {AbastecimentosViewModel} from "../model/abastecimentos-view-model";

@Component({
  selector: 'app-subfrota-edit-abastecimentos',
  templateUrl: './subfrota-edit-abastecimentos.component.html',
  styleUrls: ['./subfrota-edit-abastecimentos.component.scss']
})
export class SubfrotaEditAbastecimentosComponent implements OnInit {


  filtroForm: FormGroup;

  public dataSource!: MatTableDataSource<AbastecimentosViewModel>;
  public displayedColumns!: string[];
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;



  public loading = 0;
  usuario !: LoginModel | undefined;
  isCollapsed: boolean = false;
  listaCombustiveis: NomeCombustivel[] = [];


  constructor(
    private fb: FormBuilder,
    private subFrotaService: SubfrotaService,
    private authenticationService: AuthenticationService,
    private snackBar: SnackBarService,
    private renderer: Renderer2
  ) {
    this.filtroForm = this.fb.group({
      dscPlaca: ['', Validators.maxLength(7)],
      codFrota: ['', Validators.maxLength(6)],
      codPosto: ['', Validators.maxLength(6)],
      indCombustivel: [''],
      datIniAbastecimento: ['', [this.DataNaoFutura]],
      datFimAbastecimento: ['', [this.DataNaoFutura, this.DataFinalNaoAteriorInicial]],
    })


  }

   ngOnInit(): void {


    // Liga a animação de Loading (Spinner) na tela
    this.loading++;

    // Verifica se o guid do usuário é ou continua válido.
    this.authenticationService.validate(this.subFrotaService?.usuario?.retorno?.guid ?? '')
      .then((dados => {

        if (!dados.sucesso) {
          this.snackBar.flashMessage(this.authenticationService.msgSessaoExpirada, ['snackbar-error'], 'Fechar', 0);
          this.usuario = undefined;

        } else {
          this.usuario = this.subFrotaService.usuario;

          if(this.usuario.retorno.tipo === 2){
            this.displayedColumns = [ 'flgEditavel', 'nomFantasiaPosto', 'dscPlaca', 'datAbastecimento', 'indCombustivel', 'qtdVolume', 'vlrUnitario', 'vlrTotal', 'numKm',];
          }else {
            this.displayedColumns = [ 'flgEditavel', 'codFrota', 'dscPlaca', 'datAbastecimento', 'indCombustivel', 'qtdVolume', 'vlrUnitario', 'vlrTotal', 'numKm',];
          }


          this.iniciar();

        }
      }))
      .catch(() => {
        this.snackBar.flashMessage(this.authenticationService.msgSessaoExpirada, ['snackbar-error'], 'Fechar', 0);
      })
      .finally(() => {
        this.loading--;
      });

  }

   private async iniciar() {

    this.renderer.addClass(document.body, this.usuario?.retorno?.aparencia ?? "PADRAO");
    await this.getTiposCombustiveis();
    await this.buscarDadosAbastecimentos();
  }

  private DataNaoFutura(control: FormControl) {
    const data = new Date(control.value);
    const dataAtual = new Date();

    if (isNaN(dataAtual.getTime()))
      return null;

    if (data > dataAtual) {
      return {invalidDateRange: true}
    }
    return null;
  }

  async getTiposCombustiveis() {

    await this.subFrotaService.getListaCombustiveis(this.subFrotaService?.usuario?.retorno?.guid)
      .subscribe(ret => {
        if (!ret.sucesso) {
          console.log("Erro no retorno da api: " + ret.mensagens)
        } else {
          this.listaCombustiveis = ret.retorno.filter((x: {
            descricaoCombustivel: string;
          }) => x.descricaoCombustivel != '')
          this.listaCombustiveis = this.listaCombustiveis.sort((a, b) => a.codigoCombustivel - b.codigoCombustivel);
        }
      })

  }

  private DataFinalNaoAteriorInicial(control: FormControl) {
    const dataInicio = new Date(control.root.get('datIniAbastecimento')?.value);
    const dataFim = new Date(control.value);

    if (isNaN(dataInicio.getTime()) && isNaN(dataFim.getTime()))
      return null;

    if (isNaN(dataInicio.getTime()) || dataFim < dataInicio) {
      return {invalidDataFim: true}
    }
    return null;
  }

  public filtrarDados() {
    this.buscarDadosAbastecimentos()
  }

  private async buscarDadosAbastecimentos() {

    this.loading++;

    const filtro: FiltroAbastecimentosViewModel = {
      guid: this.subFrotaService?.usuario?.retorno?.guid,
      rowsppage: 100,
    };

    if (this.filtroForm.get('codPosto')?.value != '')
      filtro.codPosto = this.filtroForm.get('codPosto')?.value;

    if (this.filtroForm.get('codFrota')?.value != '')
      filtro.codFrota = this.filtroForm.get('codFrota')?.value;


    if (this.filtroForm.get('dscPlaca')?.value != '')
      filtro.dscPlaca = this.filtroForm.get('dscPlaca')?.value;

    if (this.filtroForm.get('indCombustivel')?.value != '')
      filtro.indCombustivel = this.filtroForm.get('indCombustivel')?.value;

    if (this.filtroForm.get('datIniAbastecimento')?.value != '')
      filtro.datIniAbastecimento = this.filtroForm.get('datIniAbastecimento')?.value;

    if (this.filtroForm.get('datFimAbastecimento')?.value != '')
      filtro.datFimAbastecimento = this.filtroForm.get('datFimAbastecimento')?.value;


    this.subFrotaService.obterListaAbastecimentosDaFrota(filtro).subscribe(ret => {
      if (ret.sucesso) {
         // ret.retorno.map(x=> x.flgEditavel = true);
        this.dataSource = new MatTableDataSource<AbastecimentosViewModel>(ret.retorno );
        // console.log(this.dataSource.data)
         this.dataSource.paginator = this.paginator;
         this.sort.sort(({ id: 'codigoAbastecimento', start: 'desc' }) as MatSortable);
         this.dataSource.sort = this.sort;
         this.sort.sort(({ id: 'codigoAbastecimento', start: 'asc' }) as MatSortable);
         this.sort.disableClear = true;
         this.dataSource.sort = this.sort;


      } else {
        const msgs = ret.mensagens.join("\n");
        this.snackBar.flashMessage(msgs, ['snackbar-error'], 'Fechar', 0);
      }
    })

    this.loading--;
  }

  mostrarNomeCombustivel(indCombustivel: string) {
    const comb = this.listaCombustiveis.find(x=> x.descricaoCombustivel.trim().toUpperCase() === indCombustivel.trim().toUpperCase());
    return comb?.combustivel == undefined ? '' : comb.combustivel;
  }
}
